import { render } from "./simple-facility-card.vue?vue&type=template&id=56e1b898&scoped=true"
import script from "./simple-facility-card.vue?vue&type=script&lang=js"
export * from "./simple-facility-card.vue?vue&type=script&lang=js"

import "./simple-facility-card.vue?vue&type=style&index=0&id=56e1b898&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e1b898"]])

export default __exports__